module.exports = __webpack_public_path__ + "img/presupuesto.66de120f.svg";